import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { UserPreferencesState } from '@/store/userPreferences/state.ts';
import { toBase64 } from '@/utils/toBase64.ts';

export const updateUserPreferences = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, UserPreferencesState>({
    query: (params) => ({
      url: '/userdata/userpref',
      method: 'POST',
      body: adaptUserPreferenceUpdatePayload(params),
    }),
    invalidatesTags: ['getCurrentUser'],
  });
};

function adaptUserPreferenceUpdatePayload(params: UserPreferencesState): UserPreferencesState {
  return {
    ...params,
    emails: params.emails.map(toBase64),
    splitNotificationsEmailsCash: params.splitNotificationsEmailsCash.map(toBase64),
    splitNotificationsEmailsOrders: params.splitNotificationsEmailsOrders.map(toBase64),
    splitNotificationsEmailsOptions: params.splitNotificationsEmailsOptions.map(toBase64),
  };
}
